import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary, { reportClientError } from "@/components/ErrorBoundary";

// Traduction automatique du navigateur (Chrome/Safari) ou extensions : elles remplacent les nœuds texte par des <font>,
// puis React échoue sur removeChild/insertBefore ("The node to be removed is not a child of this node"). On rend ces appels tolérants.
if (typeof Node === "function" && Node.prototype) {
  let reported = false;
  const reportOnce = (op) => {
    if (reported) return;
    reported = true;
    reportClientError({ kind: "dom-guard", message: `${op} ignoré : nœud déplacé hors de React (traduction automatique du navigateur ?)`, stack: "" });
  };
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) { reportOnce("removeChild"); return child; }
    return originalRemoveChild.apply(this, arguments);
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) { reportOnce("insertBefore"); return newNode; }
    return originalInsertBefore.apply(this, arguments);
  };
}

window.addEventListener("error", (e) => reportClientError({ kind: "window", message: e?.message || "", stack: e?.error?.stack || "" }));
window.addEventListener("unhandledrejection", (e) => {
  const r = e?.reason;
  if (r?.response?.status) return; // erreurs HTTP déjà gérées par l'UI
  reportClientError({ kind: "promise", message: r?.message || String(r), stack: r?.stack || "" });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (registration) => {
        console.log('SW registered:', registration.scope);
      },
      (error) => {
        console.log('SW registration failed:', error);
      }
    );
  });
}
